import styles from './index.module.scss';

export default function FallbackHeader() {
  return (
    <div className={styles.box_header}>
      <div className={styles.container_loader}>
        <div className={styles.orange_circle} />
        <div className={styles.blue_circle} />
      </div>
    </div>
  );
}
